/**
 * Build styles
 */
import './index.css';
import { IconBold } from '@codexteam/icons'

export default class Bold {

  static get CSS() {
    return 'cdx-bold';
  };

  constructor({ api }) {
    this.api = api;
    this.button = null;

    this.tag = 'B';

    this.iconClasses = {
      base: this.api.styles.inlineToolButton,
      active: this.api.styles.inlineToolButtonActive,
    };
  }


  static get isInline() {
    return true;
  }

  render() {
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.classList.add(this.iconClasses.base);
    this.button.innerHTML = this.toolboxIcon;

    return this.button;
  }

  surround(range) {
    if (!range) {
      return;
    }

    const termWrapper = this.api.selection.findParentTag(this.tag, Bold.CSS);

    if (termWrapper) {
      this.unwrap(termWrapper);
    } else {
      this.wrap(range);
    }
  }


  wrap(range) {

    const b = document.createElement(this.tag);

    b.classList.add(Bold.CSS);

    b.appendChild(range.extractContents());
    range.insertNode(b);


    this.api.selection.expandToTag(b);
  }

  unwrap(termWrapper) {

    this.api.selection.expandToTag(termWrapper);

    const sel = window.getSelection();
    const range = sel.getRangeAt(0);

    const unwrappedContent = range.extractContents();

    termWrapper.parentNode.removeChild(termWrapper);

    range.insertNode(unwrappedContent);

    sel.removeAllRanges();
    sel.addRange(range);
  }

  checkState() {
    const termTag = this.api.selection.findParentTag(this.tag, Bold.CSS);

    this.button.classList.toggle(this.iconClasses.active, !!termTag);
  }
    
  get toolboxIcon() {
    return IconBold;
  }

  static get sanitize() {
    return {
      b: {
        class: Bold.CSS,
      },
    };
  }
}